import { ReactElement, useCallback } from 'react';

import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { listByType } from '../../api';
import { AdditionalCharge } from '../../interfaces/types';

interface BaseLoaderProps {
  type: string;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  string,
  AdditionalCharge[],
  AxiosResultDefaultError
>();

export function useAdditionalChargesLoader() {
  return useFetch();
}

export default function AdditionalChargesLoader({
  type,
  children,
}: BaseLoaderProps) {
  const request = useCallback(async (chargeType: string) => {
    return listByType(chargeType);
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={type} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading className="mx-auto" />;
          } else if (error) {
            return (
              <div className="w-100 d-flex justify-content-center">
                <DisplayError textBody={error.code} retryAction={refresh} />
              </div>
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
